import { URL } from '../service/endpoints';

const STORAGE_PREFIX = 'hiller_'

export const setLocalStorage = (key, value) => {
  localStorage.setItem(STORAGE_PREFIX + key, value)
}

export const getLocalStorage = (key) => {
  return localStorage.getItem(STORAGE_PREFIX + key)
}

export const removeLocalStorage = (key) => {
  localStorage.removeItem(STORAGE_PREFIX + key)
}


/**
 * Helper function to determine if a color is light or dark.
 * Supports hex and rgb(a) color formats.
 * Returns 'black' for light colors and 'white' for dark colors.
 */
export const getContrastingTextColor = (fillColor) => {
  let r, g, b;

  if (fillColor.startsWith('#')) {
    // Remove the hash if present
    const hex = fillColor.slice(1);

    // Expand shorthand form (e.g., "03F") to full form ("0033FF")
    const fullHex = hex.length === 3
      ? hex.split('').map(char => char + char).join('')
      : hex;

    if (fullHex.length !== 6) {
      // Invalid format
      return 'black';
    }

    r = parseInt(fullHex.substring(0, 2), 16);
    g = parseInt(fullHex.substring(2, 4), 16);
    b = parseInt(fullHex.substring(4, 6), 16);
  } else if (fillColor.startsWith('rgb')) {
    const rgbValues = fillColor.match(/\d+/g);
    if (!rgbValues || rgbValues.length < 3) {
      // Invalid format
      return 'black';
    }
    [r, g, b] = rgbValues.map(Number);
  } else {
    // Unsupported format, default to black
    return 'black';
  }

  // Calculate luminance using the formula
  // https://www.w3.org/TR/WCAG20/#relativeluminancedef
  const a = [r, g, b].map((v) => {
    const sRGB = v / 255;
    return sRGB <= 0.03928
      ? sRGB / 12.92
      : Math.pow((sRGB + 0.055) / 1.055, 2.4);
  });

  const luminance = 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];

  // Contrast ratio threshold (WCAG recommends 4.5 for normal text)
  // Here, we use 0.179 as the luminance threshold
  return luminance > 0.179 ? 'black' : 'white';
};

/**
 * Fetch a fresh SAS URL for a blob from the API
 * @param {string} blobId - The blob ID
 * @returns {Promise<string>} - The URL with fresh SAS token
 */
export const getBlobUrl = async (blobId) => {
  try {
    const response = await fetch(`${URL}/images/blob/${blobId}/url`);
    if (!response.ok) throw new Error('Failed to fetch blob URL');
    const data = await response.json();
    return data.url;
  } catch (error) {
    console.error('Error fetching blob URL:', error);
    return null;
  }
};
